import React, { useState} from 'react';
import { Box, Button } from '@material-ui/core';
import clsx from 'clsx';
import CellphoneLinkIcon from 'mdi-react/CellphoneLinkIcon';
import { Wrapper } from '../../styling/Styles';
import SimpleLoginPopUp from './SimpleLoginPopUp';

const SimpleLogin = ({ data, setData, dispatch }) => {
  const [isLoginPressed, setIsLoginPressed] = useState(false);

  return (
    <>
      {' '}
      <Box display="flex">
        <div
          style={{
            fontSize: '0.9vw',
            width: '15vw',
            textAlign: 'center'
          }}
          className={('parent', clsx('marginAuto', 'lightBlue'))}
        >
          Login with workshop&apos;s provided accounts!
        </div>
      </Box>
      <Wrapper style={{ marginTop: '1vw' }}>
        {data.errorMessage && (
          <section className="container">
            <span>{data.errorMessage}</span>
          </section>
        )}

        {data.isLoading && (
          <section className="container">
            <div className="login-container">
              <div className="loader-container">
                <div className="loader" />
              </div>
            </div>
          </section>
        )}
        {!isLoginPressed && !data.isLoading && (
          <section style={{display: 'flex', justifyContent: 'center',paddingBottom: '2vw'}}>
            <div>
              
              <Button
                
                style={{
                  backgroundColor: '#0c4d82',
                  borderRadius: '8px',
                  borderColor: '#0c4d82',
                  color: '#fff',
                  display: 'flex',
                  fontFamily: 'Open Sans',
                  cursor: 'pointer',
                  textTransform: 'none',
                  paddingLeft: '0.1rem',
                  paddingRight: '0.1rem',
                  minWidth: '10vw',
                  margin: '0px'
                }}
                type="button"
                onClick={() => {
                  setIsLoginPressed(true);
                }}
              >
                <CellphoneLinkIcon />
                <span id='simpleLoginButton' style={{ marginLeft: '5px', fontSize: '1vw' }}>Login </span>
              </Button>
            </div>
          </section>
        )}
      </Wrapper>
      <SimpleLoginPopUp
        openAlert={isLoginPressed}
        setOpenAlert={setIsLoginPressed}
        setData={setData}
        dispatch={dispatch}
      />
    </>
  );
};

export default SimpleLogin;
